import { recordOf } from "@altostra/type-validations";
import type { AnyTypeValidation } from "@altostra/type-validations";

export const recordExcludingArraysOf = <T>(validator: AnyTypeValidation<T>) => {
  const isRecord = recordOf(validator);
  return (value: unknown): value is Record<string, T> => !Array.isArray(value) && isRecord(value);
};
